import NewSurveyProjectContainer from './new/NewSurveyProjectContainer';
import SurveyProjectDetailContainer from './detail/SurveyProjectDetailContainer';
import SurveyImportDetail from './import/ImportDetail';
import SurveyProjectListContainer from './SurveyProjectListContainer';

const surveyProjectRoutes = [
  { path: '/accounts/:aid/survey-projects/', component: SurveyProjectListContainer, exact: true },
  { path: '/accounts/:aid/survey-projects/new', component: NewSurveyProjectContainer },
  {
    path: '/accounts/:aid/survey-projects/:surveyProjectId/imports/:importId',
    component: SurveyImportDetail,
  },
  {
    path: '/accounts/:aid/survey-projects/:surveyProjectId',
    component: SurveyProjectDetailContainer,
    exact: true,
  },
];

export default surveyProjectRoutes;
